export var questionData: any =
    [
        {
            "difficulty": 1,
            "questions": [
                {
                    "question": "What comes next: 25, 30, 35…?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "45",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "50",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "40",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is one more than 19?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "18",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "20",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "10",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which is the odd number?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "2",
                            "sfxID": "2"
                        },
                        {
                            "label": "3",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "4",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 20 – 4?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "16",
                            "sfxID": "16",
                            "correct": true
                        },
                        {
                            "label": "22",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "14",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 7 + 4?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "10",
                            "sfxID": "10"
                        },
                        {
                            "label": "11",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "12",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is the difference between 8 and 3?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "6",
                            "sfxID": "6"
                        },
                        {
                            "label": "3",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "5",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 8 + 8?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "14",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "18",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "16",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What comes next: 8, 10, 12 …?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "14",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "18",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "16",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which is the even number?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "11",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "12",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "13",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What comes next: 50, 60, 70 …?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "60",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "80",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "100",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Reduce means what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "using less",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "using something again",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "using more",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Reuse means what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "recycling",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "using something again",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "ordering double",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these things CAN’T be composted?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "apple",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "potato peelings",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "chips",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these things CAN’T be recycled?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "crisp packet",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        },
                        {
                            "label": "tin of beans",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "cardboard box",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which one of the 3Rs is missing from this list: Reduce, Reuse, what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "Remember",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "Rubbish",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "Recycle",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "If somebody is doing something good for the planet, what colour do we say they are?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "red",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "blue",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "green",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these foods do we throw away the most of in the UK?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "sliced bread",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        },
                        {
                            "label": "apples",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "potatoes",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these items is made from plastic?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "drinks can",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "water bottle",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "book",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What creature helps rotten fruit and veg to break down in the compost heap?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "bird",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "mouse",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "worm",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Plastic is made from what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "sand",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        },
                        {
                            "label": "oil",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "water",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                }
            ]
        },
        {
            "difficulty": 2,
            "questions": [
                {
                    "question": "What comes next: 9, 12, 15, …",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "21",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "18",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "17",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these numbers is < 10?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "7",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "11",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "20",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 30 + 70?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "10",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "73",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "100",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "20 is half of what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "40",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "10",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "20",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is ½ of 6?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "3",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "2",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "12",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "How many sides does a pentagon have?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "5",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "7",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "9",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "How many edges does a cuboid have?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "6",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "8",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "12",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 80 – 40?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "30",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "40",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "50",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 4 x 5?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "10",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "20",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "30",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What is 30 divided by 10?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "3",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "10",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "20",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which meal produces the most rubbish?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "breakfast",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "lunch",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "dinner",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these items can’t be composted?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "Apple",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "meat bones",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "teabags",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Recycling means what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "using less of something",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "turning something old into something new",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "burning something",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What SHOULDN’T you do with your plastic water bottle when you’ve finished with it?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "throw it away",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "recycle it",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "reuse it",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these CAN’T be made from plastic?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "clothes",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "sweets",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "water bottles",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "What should you do with any leftover food?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "throw it away",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "see if you can compost it",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "plant it in the garden",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Which of these items CAN’T be recycled?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "nappy",
                            "sfxID": "medium_question_which-good-insulator_rubber",
                            "correct": true
                        },
                        {
                            "label": "batteries",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "yoghurt pot",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Reduce, Reuse and Recycle are known as the what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "2Rs",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "3Rs",
                            "sfxID": "medium_question_which-good-insulator_a-fork",
                            "correct": true
                        },
                        {
                            "label": "4Rs",
                            "sfxID": "medium_question_which-good-insulator_plastic"
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "The biggest source of rubbish in primary schools is… what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "metal",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "paper",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "food",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                },
                {
                    "question": "Complete the expression: from farm to what?",
                    "sfxID": "medium_question_which-good-insulator",
                    "options": [
                        {
                            "label": "spoon",
                            "sfxID": "medium_question_which-good-insulator_rubber"
                        },
                        {
                            "label": "knife",
                            "sfxID": "medium_question_which-good-insulator_a-fork"
                        },
                        {
                            "label": "fork",
                            "sfxID": "medium_question_which-good-insulator_plastic",
                            "correct": true
                        }
                    ],
                    "response": ""
                }
            ]
        }
    ];



// WEBPACK FOOTER //
// ./src/ts/data/Questions.ts